import React from 'react';
import '../Toast.scss';

export const ErrorToast = ({ errorCode, message }) => (
    <div className={'content'}>
        <i className="material-icons">warning</i>
        <span>{`${errorCode || 'API Error'}: ${message}`}</span>
    </div>
);
